export default __webpack_public_path__ + "static/media/alignLeft.c0f5031c.svg";